import React from "react";
import l from "components/util/l";
import Start from "components/presentation/start/Start";
import "styles/css/presentation/AppMenu.css";

const AppMenuView = ({
  activeFlow,
  isCollapsed,
  isStartShown,
  items,
  showFlows,
  title,
  closeStart,
  onClickItem,
  onClickToggleStart
}) => (
  <nav className={"app-menu " + (isCollapsed ? "collapsed " : " ")} data-testid="app-menu">

    {/* Header: which solution this is, and the way out of it */}
    <button
      className="app-menu-flow"
      data-testid="app-menu-flow-btn"
      type="button"
      disabled={!showFlows}
      onClick={onClickToggleStart}
      title={showFlows ? l("Cambiar de solución%SB086") : title}
    >
      <span className="app-menu-flow-logo"
        style={activeFlow.theme?.logo ? { backgroundImage: `url(${activeFlow.theme.logo})` } : {}}>
        {!activeFlow.theme?.logo && <i className="fas fa-agent"></i>}
      </span>
      <span className="app-menu-flow-name">{title}</span>
      {showFlows &&
        <i className={"app-menu-flow-caret fas " + (isStartShown ? "fa-chevron-up" : "fa-chevron-down")}></i>}
    </button>

    <div className="app-menu-items">
      {items.map(item => (
        <button
          key={item.path}
          className={"app-menu-item " + (item.isActive ? "active " : " ")}
          data-testid={`app-menu-item-${item.testId}`}
          type="button"
          onClick={() => onClickItem(item.path)}
          title={item.label}
        >
          <i className={"app-menu-item-icon " + (item.icon || "fas fa-circle")}></i>
          <span className="app-menu-item-label">{item.label}</span>
          {item.badge != null &&
            <span className="app-menu-item-badge">{item.badge}</span>}
        </button>
      ))}

      {items.length == 0 &&
        <p className="app-menu-empty">{l("Sin secciones%SB085")}</p>}
    </div>

    {/* The solution list is the platform's start panel, not a copy of it: the same
        component the topbar's button opens, over the app instead of beside the menu —
        it is a full screen of folders, cards and stats that no 260px column could hold. */}
    {isStartShown &&
      <div className="app-menu-start animate__animated animate__fadeInLeft animate__faster">
        <Start
          currentFlow={activeFlow}
          closeStart={closeStart}
        />
      </div>}

  </nav>
);

export default AppMenuView;
